import { history } from "../../_helpers";
import notificacionService from "./notification.service";

class AuthService {

    authenticated:any;

    user:any;

    urlToRedirect:any;

    constructor() {
        let user:any = localStorage.getItem("userAutopartes");
        let extraInfo:any = localStorage.getItem("extraInfo");

        this.authenticated =( user!=null && user != undefined && JSON.parse(user).token !== undefined);

        if (this.authenticated){
            this.user = JSON.parse(user);         
            setTimeout(()=>{                
               this.realoadNotifications();
            }, 300);  
        } 
        if (this.authenticated && !!extraInfo) this.user.detail = JSON.parse(extraInfo);
       
    }

    realoadNotifications = () => notificacionService.initialize();

    isAuthenticated = () :boolean=> this.authenticated;

    getLoggedUser = () :any => this.user;

    getLoggedUserDetail = () :any => this.user?.detail;

    isMercadoPagoHabilitado = () :boolean => {
        return this.user?.detail?.mercadoPagoHabilitado;
    };    

    hasAuthority = (authority: any): boolean => {
        if(this.isAuthenticated()){
            return this.user.roles?.some((it: any) => it == authority);
        }else{
            return false;
        }
        
    };

    /**
     * Permiso dentro de la cuenta (enum Permiso del back). Lo trae el login en `permisos`.
     *
     * Una sesion de antes de que existieran los permisos no los tiene: ahi se deja pasar, porque
     * hasta entonces todo el que vendia era dueño de su cuenta. El control de verdad lo hace el
     * back (PermisoInterceptor); esto solo arma el menu.
     */
    hasPermiso = (permiso: string): boolean => {
        if (!this.isAuthenticated()) return false;
        // El dueño tiene todo siempre, aunque su sesion sea de antes de que existiera el permiso.
        if (this.user?.esDuenoCuenta === true) return true;
        const permisos = this.user?.permisos;
        if (!Array.isArray(permisos)) return true;
        return permisos.includes(permiso);
    };

    /**
     * Si la cuenta puede publicar bajas y motores ("negocio desarmadero"). Una sesion de antes de la
     * marca no la trae: ahi se deja pasar, porque todas las cuentas de entonces la tienen prendida.
     */
    esDesarmadero = (): boolean => this.user?.cuentaDesarmadero !== false;

    /** El vendedor en cuyo nombre opera (el dueño de la cuenta). Sesion vieja: el propio usuario. */
    vendedorEfectivoId = (): any => this.user?.vendedorEfectivoId ?? this.user?.id;

    /** Dueño de la cuenta (o sesion vieja, que solo podia ser de un dueño). */
    esDuenoCuenta = (): boolean => this.isAuthenticated() && this.user?.esDuenoCuenta !== false;

    hasAnyAuthorities = (authorities: any[]): boolean => {
        let hasAny = false;
        if(!!authorities && authorities.length>0){
            authorities.forEach(name => {
                if(this.hasAuthority(name)){                   
                    hasAny = true;
                }
            });
        }

        return hasAny;
    };

    setExtraInfo = (extraInfo:any) => {
        localStorage.setItem("extraInfo", JSON.stringify(extraInfo));
        this.user.detail = extraInfo;

        // El perfil no vive en redux: quien depende de un dato de la sesion —hoy el cartel que exige
        // el celular— no tiene forma de enterarse de que se refresco. El evento es esa forma.
        window.dispatchEvent(new CustomEvent("sesion-actualizada", {detail: extraInfo}));
    }

    goToLoginAndSetOnLoginSuccess = (urlToRedirect:any) => {
      this.urlToRedirect = urlToRedirect;
      history.push('/login');
    }

    userLoginSucess = () => {
        let user = localStorage.getItem("userAutopartes");
        let extraInfo = localStorage.getItem("extraInfo");

        this.authenticated = !!user ? true : false;

        if (!!user) this.user = JSON.parse(user);
        if (!!user && !!extraInfo) this.user.detail = JSON.parse(extraInfo);

        notificacionService.initialize();

        if(this.urlToRedirect !=undefined){
            setTimeout(()=>{                
                history.push(this.urlToRedirect);
                this.urlToRedirect = undefined;
            }, 250);
           
        }
    }

    userLogout = () => {
        // Antes de soltar la sesion: si el socket del usuario que se va queda abierto, la proxima
        // cuenta que entre en este navegador sigue recibiendo sus mensajes.
        notificacionService.shutdown();
        localStorage.removeItem("userAutopartes");
        localStorage.removeItem("extraInfo");
        this.authenticated = false;
        this.user = undefined;        
    }

    formatUserName = (usuario:any):string => {
        let finalName = '';

        if(!!usuario){
            if(!!usuario.firstName){
                finalName = usuario.firstName + ' ' + usuario.lastName + "("+ usuario.username +")"
            }else{
                finalName = usuario.username;
            }
        }

        return finalName;
    }
     
}


const authService = new AuthService();

export default authService;